import React from "react";

const About = () => {
  const isLocalHost =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  // Production always uses the custom booking host so stale Vercel preview URLs
  // baked into REACT_APP_BOOKING_PWA_URL cannot leak into Book Now.
  const bookingPwaUrl = isLocalHost
    ? process.env.REACT_APP_BOOKING_PWA_URL || "http://localhost:3001"
    : "https://booking.echojham.site";
  const largePhotoSrc = "/assets/aboutus_photos/echojham_team.jpg";
  const leftTopPhotoSrc = "/assets/aboutus_photos/echojham.aboutus01.jpg";
  const rightTopPhotoSrc = "/assets/aboutus_photos/echojham.aboutus02.jpg";
  const [largePhotoFailed, setLargePhotoFailed] = React.useState(false);
  const [leftPhotoFailed, setLeftPhotoFailed] = React.useState(false);
  const [rightPhotoFailed, setRightPhotoFailed] = React.useState(false);
  const missionCarouselImages = [
    "/assets/aboutus_photos/echojham.aboutus1.jpg",
    "/assets/aboutus_photos/echojham.aboutus2.jpg",
    "/assets/aboutus_photos/echojham.aboutus3.jpg",
    "/assets/aboutus_photos/echojham.aboutus4.jpg",
    "/assets/aboutus_photos/echojham.aboutus5.jpg",
  ];
  const [missionCarouselIndex, setMissionCarouselIndex] = React.useState(0);
  const [missionCarouselImageFailed, setMissionCarouselImageFailed] = React.useState(false);
  const [activeInfoTab, setActiveInfoTab] = React.useState("services");

  const services = [
    "Concerts",
    "Product Launch",
    "Brand Activations",
    "Sporting Events",
    "Sales Conference",
    "Lifestyle & Fashion Events",
    "Seminars/ Webinars",
    "Video and Photo Coverage",
    "Creatives",
    "Artist Booking",
    "TV Coverage",
    "Audio and Video Presentation",
  ];

  const majorVenues = [
    "The Theatre at Solaire",
    "Newport Performing Arts Theater",
    "Music Museum",
    "Cebu Waterfront Hotel & Casino",
    "New Frontier Theatre",
    "Marquis Event Place",
    "The Blue Leaf Event Pavilion",
    "Element@Centris",
    "PICC",
    "Aliw Theatre",
    "Meralco Theatre",
    "Makati Shangri-La Hotel",
    "Edsa Shangri-La Hotel",
    "Manila Marriot Hotel",
    "Teatrino",
    "Skydome",
    "Cuneta Astrodome",
    "Cove Manila in Okada",
    "Bar IX",
    "Vue Bar",
    "Hard Rock Cafe Makati & Manila",
  ];

  const localArtists = [
    "Martin Nievera",
    "Rey Valera",
    "Marco Sison",
    "Nonoy Zuniga",
    "Vice Ganda",
    "Ogie Alcasid",
    "The CompanY",
    "Lani Misalucha",
    "Ice Seguerra",
    "Jon Santos",
    "Christian Bautista",
    "Ariel Rivera",
    "Apo Hiking Society",
    "Dulce",
    "Kuh Ledesma",
    "Vina Morales",
    "Angeline Quinto",
    "Katrina Velarde",
    "Jake Zyrus",
    "Eric Santos",
    "Jessica Sanchez",
    "Nyoy Volante",
    "Kyla",
    "Jonah Viray",
    "Gerald Santos",
    "Nina",
    "Giselle Sanchez",
    "Daryl Ong",
    "Benj Manalo",
    "Leo Valdez",
    "Aicelle Santos",
    "Nica Del Rosario",
    "Davey Langit",
    "Cueshe'",
    "Hadji Alejandro",
    "Joey Generoso",
    "Jinky Vidal",
    "Jose Mari Chan",
    "aymond Lauchengco",
    "Roselle Nava",
    "Gino Padilla",
    "Wency Cornejo",
    "Chad Borja",
    "Luke Mejares",
    "Isha Ponti",
    "Andrea Gutierrez",
    "David Young",
    "Natasha (BOU)",
    "Zendee",
    "Marimar Tua",
    "FORTEnors",
  ];

  const internationalArtists = [
    "Boy George",
    "David Benoit",
    "David Pomeranz",
    "Jack Jones",
    "Queen Nation",
    "Rodrigo Teaser (Michael Jackson Tribute)",
  ];

  const brandPartners = [
    "Skycable",
    "Revlon",
    "Huawei",
    "Firefly",
    "Mossimo",
    "Guess",
    "Hello Kitty",
    "Jollibee",
    "Tupperware",
    "Mondelez",
    "Oppo",
    "BPI",
    "SPEEd",
    "Megaworld Lifestyle Malls",
  ];

  React.useEffect(() => {
    if (missionCarouselImages.length <= 1) return;

    const timer = window.setInterval(() => {
      setMissionCarouselIndex((prev) => (prev + 1) % missionCarouselImages.length);
    }, 3500);

    return () => window.clearInterval(timer);
  }, [missionCarouselImages.length]);

  React.useEffect(() => {
    setMissionCarouselImageFailed(false);
  }, [missionCarouselIndex]);

  return (
    <main className="min-h-[60vh] bg-[#0b0b0d] text-white">
      <section className="relative overflow-hidden border-b border-white/10">
        <div
          className="absolute inset-0 opacity-30 bg-cover bg-center"
          style={{ backgroundImage: "url('/assets/home_featured_bg.png')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/80 to-[#0b0b0d]" />

        <div className="relative max-w-6xl mx-auto px-6 py-16 md:py-24 text-center flex items-center justify-center min-h-[300px] md:min-h-[420px]">
          <img
            src="/assets/echojham.logo3.png"
            alt="Echo Jham"
            className="h-32 md:h-44 lg:h-52 mx-auto"
          />
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-black uppercase tracking-tight">
            About Us
          </h2>
          <div className="mt-3 w-16 h-1 bg-brand-maroon mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-8 lg:gap-10 items-start">
          <div className="space-y-6">
            <div className="flex gap-4 items-start">
              <div className="w-3 h-28 md:h-36 bg-gradient-to-b from-brand-maroon to-[#6b0000] rounded-sm shrink-0" />
              <p className="text-xl md:text-2xl font-black leading-tight max-w-xl uppercase">
                We <span className="text-brand-maroon">organize, manage,</span> and
                <span className="text-brand-maroon"> produce</span> quality concerts and events in the Philippines and in other countries.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-black/25 overflow-hidden shadow-xl">
              {largePhotoSrc && !largePhotoFailed ? (
                <img
                  src={largePhotoSrc}
                  alt="About large"
                  className="w-full h-full object-cover aspect-[16/10] md:aspect-[16/9]"
                  onError={() => setLargePhotoFailed(true)}
                />
              ) : (
                <div className="aspect-[16/10] md:aspect-[16/9] flex items-center justify-center bg-white/[0.02] border border-dashed border-white/20">
                  <div className="text-center px-6">
                    <p className="text-xs uppercase tracking-[0.35em] text-white/55 font-bold">Photo Slot</p>
                    <p className="mt-2 text-sm text-white/70">Insert large team or event photo here</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="space-y-6 lg:pt-14">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden shadow-lg">
                {leftTopPhotoSrc && !leftPhotoFailed ? (
                  <img
                    src={leftTopPhotoSrc}
                    alt="About left"
                    className="w-full h-full object-cover aspect-[4/3]"
                    onError={() => setLeftPhotoFailed(true)}
                  />
                ) : (
                  <div className="aspect-[4/3] flex items-center justify-center bg-white/[0.02] border border-dashed border-white/20">
                    <div className="text-center px-4">
                      <p className="text-xs uppercase tracking-[0.35em] text-white/55 font-bold">Photo Slot</p>
                      <p className="mt-2 text-xs text-white/65">Insert photo here</p>
                    </div>
                  </div>
                )}
              </div>

              <div className="rounded-2xl border border-white/10 bg-white/[0.03] overflow-hidden shadow-lg">
                {rightTopPhotoSrc && !rightPhotoFailed ? (
                  <img
                    src={rightTopPhotoSrc}
                    alt="About right"
                    className="w-full h-full object-cover aspect-[4/3]"
                    onError={() => setRightPhotoFailed(true)}
                  />
                ) : (
                  <div className="aspect-[4/3] flex items-center justify-center bg-white/[0.02] border border-dashed border-white/20">
                    <div className="text-center px-4">
                      <p className="text-xs uppercase tracking-[0.35em] text-white/55 font-bold">Photo Slot</p>
                      <p className="mt-2 text-xs text-white/65">Insert photo here</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="max-w-xl mx-auto lg:mx-0 text-center lg:text-left px-2 lg:px-0">
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">
                <span className="text-brand-maroon font-black">ECHOJHAM Entertainment Production</span> is a premier event and entertainment firm dedicated to bringing high-quality performances to the stage. We specialize in end-to-end production management, from conceptualizing live events and managing artist logistics to executing large-scale concerts and theatrical shows. Our focus is on elevating the entertainment standard by combining professional expertise with a deep passion for the performing arts.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="relative overflow-hidden border-y border-white/10"
        style={{
          backgroundImage: "url('/assets/aboutus_photos/echojham.aboutus.bgOnVision&Mission.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/75" />

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 md:gap-12 items-center">
            <div className="space-y-8 text-center lg:text-left">
              <div>
                <div className="w-fit mx-auto lg:mx-0">
                  <h3 className="text-2xl md:text-3xl font-black">Our Mission</h3>
                  <div className="mt-2 h-1 w-16 bg-brand-maroon rounded-full mx-auto" />
                </div>
                <p className="mt-3 text-sm md:text-base text-white/85 leading-relaxed max-w-md mx-auto lg:mx-0">
                  To empower the entertainment industry by providing world-class production services that connect artists with their audiences. We strive to deliver excellence in every show, ensuring that every event we produce is a seamless blend of creativity, professionalism, and technical precision.
                </p>
              </div>

              <div>
                <div className="w-fit mx-auto lg:mx-0">
                  <h3 className="text-2xl md:text-3xl font-black">Our Vision</h3>
                  <div className="mt-2 h-1 w-16 bg-brand-maroon rounded-full mx-auto" />
                </div>
                <p className="mt-3 text-sm md:text-base text-white/85 leading-relaxed max-w-md mx-auto lg:mx-0">
                  To be recognized as the leading entertainment production house in the region, known for fostering talent and creating legendary live experiences that leave a lasting impact on the community.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-white/15 bg-black/35 overflow-hidden shadow-2xl">
              {missionCarouselImages[missionCarouselIndex] && !missionCarouselImageFailed ? (
                <img
                  src={missionCarouselImages[missionCarouselIndex]}
                  alt={`Mission carousel ${missionCarouselIndex + 1}`}
                  className="w-full aspect-[16/10] object-cover"
                  onError={() => setMissionCarouselImageFailed(true)}
                />
              ) : (
                <div className="w-full aspect-[16/10] flex items-center justify-center bg-white/[0.02] border border-dashed border-white/20">
                  <div className="text-center px-6">
                    <p className="text-xs uppercase tracking-[0.35em] text-white/55 font-bold">Carousel Photo Slot</p>
                    <p className="mt-2 text-sm text-white/70">Insert mission carousel photos in /assets/aboutus_photos/</p>
                  </div>
                </div>
              )}

              {missionCarouselImages.length > 1 ? (
                <div className="flex items-center justify-center gap-2 py-3 bg-black/50">
                  {missionCarouselImages.map((imagePath, index) => (
                    <button
                      key={`${imagePath}-${index}`}
                      type="button"
                      onClick={() => setMissionCarouselIndex(index)}
                      className={`h-2.5 rounded-full transition-all ${index === missionCarouselIndex ? "w-6 bg-white" : "w-2.5 bg-white/40 hover:bg-white/70"}`}
                      aria-label={`Go to mission carousel image ${index + 1}`}
                    />
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#0f1013] border-y border-white/10 py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-0 sm:px-0">
          <div className="text-center mb-6 md:mb-8 px-4 sm:px-6">
            <h2 className="text-3xl md:text-5xl font-black tracking-tight">What We Are Proud Of</h2>
            <div className="mt-3 w-16 h-1 bg-brand-maroon mx-auto rounded-full" />
          </div>

          <div className="bg-brand-maroon overflow-x-auto no-scrollbar">
            <div className="min-w-[700px] grid grid-cols-4 items-center">
              {[
                { id: "services", label: "Services" },
                { id: "venues", label: "Major Venues" },
                { id: "artists", label: "Artists" },
                { id: "partners", label: "Brand Partners" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveInfoTab(tab.id)}
                  className="py-3 px-4 text-sm md:text-base font-bold text-white text-center"
                >
                  <span
                    className={`inline-block pb-1 border-b-2 transition-all ${
                      activeInfoTab === tab.id ? "border-white" : "border-transparent"
                    }`}
                  >
                    {tab.label}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="mt-6 md:mt-8 rounded-3xl border border-white/10 bg-white/[0.03] p-5 md:p-8 shadow-xl mx-4 sm:mx-6">
            {activeInfoTab === "services" && (
              <div>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc pl-5">
                  {services.map((item) => (
                    <li key={item} className="text-sm text-white/90">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {activeInfoTab === "venues" && (
              <div>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc pl-5">
                  {majorVenues.map((item) => (
                    <li key={item} className="text-sm text-white/90">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {activeInfoTab === "artists" && (
              <div>
                <p className="text-sm text-white/70 mb-4">Some of the country's best performing artists</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc pl-5 mb-8">
                  {localArtists.map((item) => (
                    <li key={item} className="text-sm text-white/90">
                      {item}
                    </li>
                  ))}
                </ul>

                <p className="text-sm text-white/70 mb-4 uppercase tracking-wider">International performing artists</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc pl-5">
                  {internationalArtists.map((item) => (
                    <li key={item} className="text-sm text-white/90">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {activeInfoTab === "partners" && (
              <div>
                <p className="text-sm text-white/70 mb-4">Some of the mainstream brands</p>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2 list-disc pl-5">
                  {brandPartners.map((item) => (
                    <li key={item} className="text-sm text-white/90">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="bg-[#0b0b0d] py-12 md:py-16 border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="rounded-3xl border border-white/15 bg-gradient-to-r from-[#1a1a1f] via-[#131318] to-[#1a1a1f] p-6 md:p-10 text-center shadow-xl">
            <p className="text-xs uppercase tracking-[0.3em] text-white/60 font-bold">Ready To Work With Us?</p>
            <h3 className="mt-3 text-2xl md:text-4xl font-black uppercase">Book Your Event With Echo Jham</h3>
            <p className="mt-3 text-sm md:text-base text-white/75 max-w-2xl mx-auto">
              Start your booking request in our Event Booking Service PWA. Submit your concert or corporate event details and track your request status in real time.
            </p>

            <div className="mt-7">
              <a
                href={bookingPwaUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-brand-maroon hover:bg-[#8f0000] px-8 py-3.5 text-sm md:text-base font-black uppercase tracking-[0.08em] text-white transition-transform duration-200 hover:-translate-y-0.5"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
